import Text from "@src/lib/ui/Text";
import Widget from "@src/features/home/Widget";
import { Skeleton } from "@src/lib/ui/Skeleton";
import { gql } from "@apollo/client";
import { useUsersNoRoleWidgetCountQuery } from "@src/features/home/UsersNoRoleWidget.generated";
import UsersNoRoleSheet from "@src/features/home/UsersNoRoleSheet";
import UsersOutlineIcon from "@src/lib/icons/18px/users-outline";

const UsersNotInvitedWidget: React.FC = () => {
  const { data, loading } = useUsersNoRoleWidgetCountQuery({
    fetchPolicy: "cache-and-network",
  });
  const peopleWithoutRoleCount = data?.People.totalCount || 0;
  return (
    <Widget
      title="No Role"
      className="flex-1 self-stretch shadow-none"
      Icon={UsersOutlineIcon}
    >
      {loading && !data ? (
        <Skeleton className="h-[34px] w-10 rounded-md" />
      ) : (
        <div className="flex flex-row items-center gap-1 align-middle">
          <UsersNoRoleSheet>
            <Text
              variant="display-bold"
              className="cursor-pointer hover:underline"
            >
              {peopleWithoutRoleCount}
            </Text>
          </UsersNoRoleSheet>
        </div>
      )}
    </Widget>
  );
};

gql`
  query UsersNoRoleWidgetCount {
    People(
      input: {
        hasRole: { value: false }
        userTypes: { value: [EMPLOYEE, MANAGER] }
      }
    ) {
      totalCount
    }
  }
`;

export default UsersNotInvitedWidget;
